import { gql } from 'react-apollo';

export const createResetPasswordToken = gql`
  mutation createResetPasswordToken($input: CreateResetPasswordTokenInput!) {
    createResetPasswordToken(input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/reset_password_request/mutations/createResetPasswordToken.js